import React, {useReact} from 'react';
import { Row, Col } from 'react-bootstrap';

const View = (props) => {
    return (
        <div className="p-2">
            <div>
                Kurir pengiriman
            </div>
            <div>
                <h5>{props.courier} - {props.type}</h5>
            </div>
        </div>
    )
}

export default View